export class SerialAddModel {
    expiryDate: string | null = null;
    manufactureDate: string | null = null;
    quantity: number | null = null;
    receptionDate: any = null;
    internalSerialNumber: string | null = null;
    itemCode: string | null = null;
    manufacturerSerialNumber: string | null = null;
    batchID: string | null = null;
    warrantyStart: string | null = null;
    warrantyEnd: string | null = null;
    stringType: string | null | undefined = undefined;
    operationType: string | null | undefined = undefined;
    stringName: string | null | undefined = undefined;
    mfrStringName: string | null | undefined = undefined;
    mfrStringType: string | null | undefined = undefined;
    mfrOperType: string | null | undefined = undefined;
    numberName: string | null | undefined = undefined;
    numberValue: string | null | undefined = undefined;
    mfrNumberType: string | undefined = undefined;
    mfrNumberValue: string | null | undefined = undefined;
    mfrOperNumberType: string | null | undefined = undefined;
    mfrOperStringType: string | null | undefined = undefined;
    srNStringName: string | null | undefined = undefined;
    srStringType: string | null | undefined = undefined;
    srOperStringType: string | null | undefined = undefined;
    srNumberType: string | null | undefined = undefined;
    srNumberValue: string | null | undefined = undefined;
    srNumberStrName: string | null | undefined = undefined;
    srNumStrType: string | null | undefined = undefined;
    srOperType: string | null | undefined = undefined;
    srOperNumberType: string | null | undefined = undefined;
    lotStringType: string | null | undefined = undefined;
    lotOperStringType: string | null | undefined = undefined;
    lotStringName: string | null | undefined = undefined;
    lotNumStrName: string | null | undefined = undefined;
    lotNumStrType: string | null | undefined = undefined;
    lotOperType: string | null | undefined = undefined;
    lotNumberType: string | null | undefined = undefined;
    lotNumberValue: string | null | undefined = undefined;
    lotOperNumberType: string | null | undefined = undefined;
    binLocationValue:string| null | undefined = undefined;
}